export default __webpack_public_path__ + "media/Rispons Upload Guide.pdf";